import { QuarterCloseChecklistRowSections } from '@shared/store/workflow/workflow-types';
import { Workflow } from '@shared/store/workflow/workflow.store';

export function gatherDocumentsSectionCompleted(workflowList: Workflow[]): boolean {
  const gatherDocumentsSection = workflowList.filter((workflow) => {
    const section = Object.values(QuarterCloseChecklistRowSections).find(
      (workflowSection) => workflowSection === 'GatherDocuments'
    );

    return workflow.section === section;
  });

  return gatherDocumentsSection.every((worklow) => worklow.properties.locked);
}
